/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountValidationResponse } from '../../models/account-validation-response';

export interface UsersControllerValidateAccess$Params {
}

export function usersControllerValidateAccess(http: HttpClient, rootUrl: string, params?: UsersControllerValidateAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountValidationResponse>> {
  const rb = new RequestBuilder(rootUrl, usersControllerValidateAccess.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountValidationResponse>;
    })
  );
}

usersControllerValidateAccess.PATH = '/planning-projects/v1/users/validate-access';
